/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router-dom';

const NotFound: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    document.title = 'EHE Tracker - Page Not Found';
  }, []);

  const onButtonClick = () => {
    history.push('/');
  };

  return (
    <Result
      status="warning"
      title="Page Not Found"
      subTitle="We can't seem to find the page you're looking for."
      extra={
        <Button type="primary" size="large" onClick={onButtonClick}>
          Go Home
        </Button>
      }
    />
  );
};

export default NotFound;
